import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { SimplePopover, FilterIcon, Tag, palette } from '@dev/ee-components';
import { LandingCheckoutStatusEnum } from '@dev/ee-api/ee-api-models'; //TODO: change to paidNewsletter
import { GetAllPaidNewslettersStart } from '@/store/paidNewsletters/actions';
import { GetPaidNewslettersParams } from '@/services/ElasticApi';
import { calculateOffset } from '@/services/tools/handleUrlParams';
import { DEFAULT_ACTIVE_PAGE, DEFAULT_OFFSET } from '@/services/constants';
import { PaidNewsletterListState } from '@/store/paidNewsletters/types';
import { usePaidNewsletterParamsFromUrl } from '@/components/PaidNewsletters/hooks/useRequestParams';
import { CustomPopoverBodyProps, CustomPopoverElementProps } from '../../PaidNewsletterListInterface';
import { useStatusPopoverOptions } from '../../hooks/useStatusPopoverOptions';

const FilterContainer = styled.div`
    width: 100%;
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
`;
const FilterLabel = styled.span`
    margin-right: 10px;
    display: flex;
    align-items: center;
`;

const CustomPopoverBody = (props: CustomPopoverElementProps): JSX.Element => (
    <FilterContainer>
        <FilterLabel>{props.label}</FilterLabel>
        {!Number.isNaN(props.count) && (<Tag label={props.count} clickable={false} />)}
    </FilterContainer>
);

export const StatusFilters = ({
    paidNewsletters,
}: {
    paidNewsletters: PaidNewsletterListState;
}): JSX.Element => {
    const dispatch = useDispatch();
    const options = useStatusPopoverOptions(paidNewsletters);
    const params = usePaidNewsletterParamsFromUrl();

    if (options?.length <= 1) {
        return null;
    }
    const customDropdownBody = (el: { value: string, label: string, count: number }): JSX.Element => <CustomPopoverBody value={el.value} label={el.label} count={el.count} />;

    const handleCheckboxClick = (ev, statuses:(string | number)[]) => {
        const list = statuses.length !== 0 ? statuses : [LandingCheckoutStatusEnum.Published, LandingCheckoutStatusEnum.Unpublished]
        dispatch(GetAllPaidNewslettersStart({ ...params, offset: DEFAULT_OFFSET, page: DEFAULT_ACTIVE_PAGE, statusList: list }));
    }

    return (
        <SimplePopover
            type="icon"
            options={options}
            defaultCheckboxValue={params.statusList}
            enableCheckbox
            onCheckboxClick={handleCheckboxClick}
            popperProps={{
                disablePortal: false,
            }}
            
            customDropdownBody={customDropdownBody}
        >
            <FilterIcon color={palette.gray[5]}/>
        </SimplePopover>
    );
};